module.exports = __webpack_public_path__ + "static/media/home-graphic.3c18c492.svg";